/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_ClassesInputs */

const da_admin_nav_classes = /** @type {(inputs: Admin_Nav_ClassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasser`)
};

/** @type {(inputs: Admin_Nav_ClassesInputs) => LocalizedString} */
const en_admin_nav_classes = da_admin_nav_classes;

/**

* @param {Admin_Nav_ClassesInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const admin_nav_classes = /** @type {((inputs?: Admin_Nav_ClassesInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_ClassesInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_classes(inputs)
	return /** @type {LocalizedString} */ ("Klasser")
});